"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _masthead = _interopRequireDefault(require("@amzn/meridian-tokens/component/masthead"));

var _menu = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/menu"));

var _theme = require("../theme");

var _button2 = _interopRequireDefault(require("../button"));

var _icon = _interopRequireDefault(require("../icon"));

var _token = require("./../_utils/token");

var _filterPropsByPrefix = _interopRequireDefault(require("./../_utils/filter-props-by-prefix"));

var _reducedMotionStyles = _interopRequireDefault(require("./../_styles/reduced-motion-styles"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var styles = function styles(t, _ref) {
  var open = _ref.open;
  return (0, _emotion.css)(_objectSpread(_objectSpread({
    width: open ? t("spacingHorizontal") + t("menuButtonWidth") : 0,
    transition: t.transitionCss("menuButtonMotion", "width")
  }, _reducedMotionStyles["default"]), {}, {
    "& > button": (0, _defineProperty2["default"])({
      "float": "right",
      marginInlineStart: t("spacingHorizontal")
    }, "[dir=\"rtl\"] &", {
      "float": "left"
    })
  }));
};
/**
 * This component can be used to render a menu button in the top left of the
 * masthead. The button will animate smoothly when toggles via the "open" prop.
 */


var MastheadMenuButton = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(MastheadMenuButton, _React$Component);

  var _super = _createSuper(MastheadMenuButton);

  function MastheadMenuButton() {
    (0, _classCallCheck2["default"])(this, MastheadMenuButton);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(MastheadMenuButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          onClick = _this$props.onClick,
          open = _this$props.open;
      var passThroughProps = (0, _filterPropsByPrefix["default"])(this.props, ["data-", "aria-"]);
      return /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _masthead["default"],
        map: (0, _token.getTokenHelper)("masthead")
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: styles(t, {
            open: open
          }),
          "aria-hidden": !open
        }, /*#__PURE__*/_react["default"].createElement(_button2["default"], (0, _extends2["default"])({}, passThroughProps, {
          type: "icon",
          size: "small",
          onClick: onClick,
          tabIndex: open ? undefined : "-1"
        }), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
          tokens: _menu["default"]
        }, children)));
      });
    }
  }]);
  return MastheadMenuButton;
}(_react["default"].Component);

(0, _defineProperty2["default"])(MastheadMenuButton, "defaultProps", {
  children: "Menu",
  open: true
});
MastheadMenuButton.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * Use `aria-controls` to set the id of the menu this button will control.
   *
   * Use `aria-expanded` to communicate the expanded state of your menu to screen reader users
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Use this to set a localized accessibility label.
   */
  children: _propTypes["default"].node,

  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   */
  "data-*": _propTypes["default"].string,

  /**
   * Use this to toggle the visibility of the menu button.
   */
  open: _propTypes["default"].bool,

  /**
   * When the MastheadMenuButton is clicked you should open your main app menu
   * and set the "aria-expanded" prop of the MastheadMenuButton to true.
   */
  onClick: _propTypes["default"].func
} : {};
var _default = MastheadMenuButton;
exports["default"] = _default;